module.exports = __webpack_public_path__ + "static/media/mr.7d997a26.svg";